import { FunctionComponent } from "preact";
import { Taxon } from "@/ebird/taxonomy"; // TODO: Make the ebird file the index of types

const TaxonLink: FunctionComponent<{ taxon: Taxon }> = ({ taxon }) => {
  return <a class='species' href={`/bird?id=${taxon.taxonCode}`}>
    <span class='com-name'>{taxon.commonName} </span>
    <span class='sci-name'><i>{taxon.scientificName}</i></span>
  </a>;
}

export default TaxonLink;
